var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemberV2 = function SvgMemberV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 16.37 20.1"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xE5\\x9C\\x96\\xE5\\xB1\\xA4_1",
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#clip0_9123_27096)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.18 10.35a5.17 5.17 0 0 0 5.17-5.17C13.35 2.33 11.04 0 8.18 0a5.17 5.17 0 0 0-5.17 5.17c0 2.85 2.32 5.17 5.17 5.17zm0-8.6c1.89 0 3.42 1.53 3.42 3.42s-1.53 3.42-3.42 3.42-3.42-1.53-3.42-3.42 1.53-3.42 3.42-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.36 18.13a6.89 6.89 0 0 0-6.89-6.66H6.89A6.89 6.89 0 0 0 0 18.36c0 .96.78 1.74 1.74 1.74h12.89c.96 0 1.74-.78 1.74-1.74v-.23zm-14.61.21v-.05a5.14 5.14 0 0 1 5.14-5.08h2.58c2.83 0 5.13 2.29 5.14 5.13z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9123_27096"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16.37v20.1H0z"
  })))));
};
export default SvgMemberV2;